import Section from '../Section';

export default class FeaturedCollection extends Section {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   * @param {boolean} pageLoad
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    Array.prototype.forEach.call(
      element.querySelectorAll('.shop-now-button'),
      (shopNow) => {
        if (shopNow) {
          shopNow.addEventListener('click', this.handleShopNow);
        }
      },
    );
    this.theme.loadReviews({ badges: true });
    this.theme.addBadges(this.element, 1000);
  }

  handleShopNow = (e) => {
    e.preventDefault();
    this.theme.toggleRightDrawer('shop-now', true, { url: e.target.href });
  }
}
